import { render } from "./TemplateShape.vue?vue&type=template&id=c5fd900c&scoped=true"
import script from "./TemplateShape.vue?vue&type=script&lang=js"
export * from "./TemplateShape.vue?vue&type=script&lang=js"

import "./TemplateShape.vue?vue&type=style&index=0&id=c5fd900c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5fd900c"]])

export default __exports__